// assets
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';

// type
import { NavItemType } from '@/types/menu';

const icons = {
	EnvironmentOutlined,
	ApartmentOutlined,
	MessageOutlined
};

// ==============================|| MENU ITEMS - CITYZEN (Aplicație) ||============================== //

// Titlurile sunt chei i18n (grupul `menu.*` din translation.json) — side-drawer-ul și
// breadcrumbs fac t(title), deci textele se editează din „Gestionare texte" și se văd live.
const aplicatie: NavItemType = {
	id: 'group-aplicatie',
	title: 'menu.application',
	type: 'group',
	children: [
		{
			id: 'proiecte',
			title: 'menu.projects',
			type: 'item',
			url: '/common/project',
			icon: icons.EnvironmentOutlined,
			requiredPermission: 'projects:read'
		},
		{
			// Cartiere: listă + hartă alimentate din backend (api/neighborhoods), read-only.
			// Modul propriu în RBAC → gate pe `neighborhoods:read`.
			id: 'cartiere',
			title: 'menu.neighborhoods',
			type: 'item',
			url: '/common/cartiere',
			icon: icons.ApartmentOutlined,
			requiredPermission: 'neighborhoods:read'
		},
		{
			// Chat mediat de BE (api/chat/*). Gate pe permisiunea `chat`.
			id: 'chat',
			title: 'menu.messages',
			type: 'item',
			url: '/common/chat',
			icon: icons.MessageOutlined,
			requiredPermission: 'chat'
		}
	]
};

const cityzenGroups: NavItemType[] = [aplicatie];

export default cityzenGroups;
